import type {ComponentPropsWithRef, ReactNode} from 'react'
import {clsx} from 'clsx'
import gridStyles from './disclosure-grid.module.css'

export interface CollapsibleRegionProps extends Omit<ComponentPropsWithRef<'div'>, 'id' | 'children'> {
  id?: string
  open: boolean
  'aria-labelledby'?: string
  collapsedAriaHidden?: boolean
  children: ReactNode
}

export const CollapsibleRegion = ({
  id,
  open,
  'aria-labelledby': labelledby,
  collapsedAriaHidden = true,
  children,
  className,
  ref,
  ...rest
}: CollapsibleRegionProps) => {
  return (
    <div
      {...rest}
      ref={ref}
      id={id}
      role={labelledby && open ? 'region' : undefined}
      aria-labelledby={labelledby && open ? labelledby : undefined}
      className={clsx(gridStyles.gridRows, open && gridStyles.gridRowsExpanded, className)}
    >
      <div
        data-testid="collapsible-inner"
        className={gridStyles.clip}
        inert={!open || undefined}
        aria-hidden={!open && collapsedAriaHidden ? 'true' : undefined}
      >
        {children}
      </div>
    </div>
  )
}
